import moment from 'moment';
import { RoundLevelScore, RoundType } from 'types';

export const generateTimeString = (startTime: string, duration: number) => {
	const startTimeString = moment(startTime).format('hh:mm A');
	const endTimeString = moment(startTime).add(duration, 'minutes').format('hh:mm A');

	const timeString = `${startTimeString} - ${endTimeString}`;

	return timeString;
};

export interface GenerateScorecardChartData {
	score: number; // score should be in range 0-1
	skill: {
		name: string;
	};
}

export const generateScorecardChartData = (mss: GenerateScorecardChartData[]) => {
	const temp = mss.map((s, i) => {
		return {
			name: s.skill.name,
			userRating: Math.round(s.score),
		};
	});

	return temp;
};

export interface GenerateScorecardTableData {
	score: number; // score should be in range 0-1
	skill: {
		name: string;
	};
}

export const generateScorecardTableData = (mss: GenerateScorecardTableData[]) => {
	const temp = mss.map(s => {
		return {
			topic: s.skill.name,
			score: Math.round(s.score),
		};
	});

	return temp;
};

export const generateTabImage = (roundType: RoundType) => {
	let tabImgUrl = '';

	switch (roundType) {
		case RoundType.DSA:
			tabImgUrl = '/assets/dsaLogo.svg';
			break;

		case RoundType.Development:
			tabImgUrl = '/assets/developmentLogo.svg';
			break;

		case RoundType.LLD:
			tabImgUrl = '/assets/LLD-score.svg';
			break;

		case RoundType.HLD:
			tabImgUrl = '/assets/HLD-score.svg';
			break;

		default:
			tabImgUrl = '/assets/dsaLogo.svg';
			break;
	}

	return tabImgUrl;
};

export const generareScorecardTabsConfig = (skillScores: RoundLevelScore[], dsaScore?: number) => {
	return skillScores.map(ss => ({
		tabScore: RoundType.DSA
			? Math.round(ss.score)
				? Math.round(ss.score)
				: Math.round(dsaScore || 0)
			: Math.round(ss.score),
		key: (ss.roundType === RoundType.DSA ? RoundType.DSA_OLD : ss.roundType) as RoundType,
	}));
};
